export const MEDIA_AGENCIES_META_DESCRIPTION =
  "White-label media monitoring and media intelligence for media agencies serving brands across Southeast Europe. Become a Perceptica partner.";
